import { isDate } from './dates';
import { getNestedPropertyValue } from './objects';

export const deepCopyArray = (array) => JSON.parse(JSON.stringify(array));

export const sortByMonth = (arr) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return arr.sort((a, b) => months.indexOf(a) - months.indexOf(b));
};

export const sortCollection = (collection, key, multiplier = -1) => {
  return collection.sort((a, b) => {
    const valueA = getNestedPropertyValue(a, key);
    const valueB = getNestedPropertyValue(b, key);

    if (isDate(valueA) && isDate(valueB)) {
      return (valueA.getTime() - valueB.getTime()) * multiplier;
    }

    if (valueA < valueB) {
      return -1 * multiplier;
    }

    if (valueA > valueB) {
      return 1 * multiplier;
    }

    return 0;
  });
};

export const stringIndexArraySort = (stringArray, objectArray) => {
  const indexedArray = stringArray.map((value, index) => ({ value, index }));

  indexedArray.sort((a, b) => a.value.localeCompare(b.value));

  const sortedIndices = indexedArray.map((item) => item.index);
  const sortedObjects = sortedIndices.map((index) => objectArray[index]);

  return sortedObjects;
};
